export default __webpack_public_path__ + "static/media/1946.1c20ef00.png";